import { render } from "./WorkloadHealthScale.vue?vue&type=template&id=21cb9dc0&scoped=true"
import script from "./WorkloadHealthScale.vue?vue&type=script&lang=js"
export * from "./WorkloadHealthScale.vue?vue&type=script&lang=js"

import "./WorkloadHealthScale.vue?vue&type=style&index=0&id=21cb9dc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cb9dc0"]])

export default __exports__